export function trackEvent(event)
{
    window.pagesense = window.pagesense || [];
    window.pagesense.push(['trackEvent', event]);
}
